var render, staticRenderFns
import script from "./FeedScheduleRations.vue?vue&type=script&lang=ts"
export * from "./FeedScheduleRations.vue?vue&type=script&lang=ts"
import style0 from "./FeedScheduleRations.vue?vue&type=style&index=0&id=3df6dac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df6dac8",
  null
  
)

export default component.exports